import classNames from 'classnames';
import {support} from './utilities';
import SupportIcon from 'assets/images/support/support.svg';
import {useNavigate} from 'react-router-dom';
const Support = () => {
  const navigate = useNavigate();
  return (
    <div className="flex flex-col h-screen w-screen relative ">
      <div className="grow p-6 mt-4">
        {support.map(item => (
          <div className="flex" key={item.id}>
            <span
              className={classNames(
                item.icon,
                'ml-2 my-3 text-primary text-xl',
              )}
            ></span>
            {item.id === 0 && (
              <p
                className=" text-gray-6 my-4"
                onClick={() => navigate(item.route)}
              >
                {item.text}
              </p>
            )}
            {item.id === 1 && (
              <a className=" text-gray-6 my-4" href={`tel:${item.route}`}>
                {item.text}
              </a>
            )}
          </div>
        ))}
      </div>
      <img
        src={SupportIcon}
        alt="support"
        className=" flex-none block mx-auto mb-48"
      />
    </div>
  );
};

export default Support;
